import { ExternalLink, Globe } from "lucide-react";

export default function LinksComponent({
  icon: Icon,
  title,
  description,
  websiteLink,
}) {
  return (
    <article className="resource-link-card">
      <div className="resource-link-card__header">
        <div className="resource-link-card__icon-wrapper">
          {Icon ? (
            <Icon
              size={28}
              strokeWidth={2.2}
              className="resource-link-card__icon"
            />
          ) : (
            <Globe
              size={28}
              strokeWidth={2.2}
              className="resource-link-card__icon"
            />
          )}
        </div>

        <div className="resource-link-card__text-block">
          <h3 className="resource-link-card__title">{title}</h3>
          <p className="resource-link-card__description">{description}</p>
        </div>
      </div>

      <a
        href={websiteLink}
        target="_blank"
        rel="noreferrer"
        className="resource-link-card__visit-link"
      >
        Visit Website
        <ExternalLink size={16} />
      </a>
    </article>
  );
}
